export type BrandId = "octane" | "addie";

export interface Brand {
  id: BrandId;
  productName: string;
  supportName: string;
  supportEmail: string;
  assetPrefix: string;
}

export const BRANDS: Record<BrandId, Brand> = {
  octane: {
    id: "octane",
    productName: "Octane",
    supportName: "Octane Support",
    supportEmail: "support@tryoctane.com",
    assetPrefix: "octane",
  },
  addie: {
    id: "addie",
    productName: "Addie",
    supportName: "Addie Support",
    supportEmail: "support@addiehq.com",
    assetPrefix: "addie",
  },
};

const datasetBrand = (document.querySelector("#app") as HTMLElement | null)
  ?.dataset.brand;

export const brand: Brand =
  BRANDS[
    datasetBrand && Object.prototype.hasOwnProperty.call(BRANDS, datasetBrand)
      ? (datasetBrand as BrandId)
      : "octane"
  ];

export const assetUrl = (filename: string) =>
  `/static/img/${brand.assetPrefix}/${filename}`;
